// extracted by mini-css-extract-plugin
export default {"headerContainer":"DerivedFeaturesDetails_headerContainer__7YosV","headerLeft":"DerivedFeaturesDetails_headerLeft__YHq+w"};